"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var icon_1 = require("../../constants/img/icon");
var modules_1 = require("swiper/modules");
var UgcCarouselMain = function (_a) {
    var reviews = _a.reviews, color = _a.color, isNewUGC = _a.isNewUGC;
    var isMobile = window.innerWidth < 768 ? true : false;
    var modules = [modules_1.Navigation];
    var shouldLoop = false;
    if (reviews.length > 4 || isMobile) {
        shouldLoop = true;
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        isNewUGC && ((0, preact_1.h)("h2", { class: "redesignAb__header" }, location.pathname == '/' ? "Customer Reviews" : "Don't Just Take Our Word")),
        (0, preact_1.h)(react_1.Swiper, { className: "ugc-carousel swiper-carousel--".concat(color, " ").concat(isNewUGC && 'redesignAb__swiper'), modules: modules, pagination: { clickable: true }, slidesPerView: 1.3, loop: shouldLoop, resizeObserver: true, centeredSlides: shouldLoop, centerInsufficientSlides: shouldLoop, breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1025: {
                    slidesPerView: shouldLoop ? 3.8 : 4,
                },
            } },
            shouldLoop && (0, preact_1.h)(SwiperNavArrows_1.default, { color: color }),
            reviews.map(function (review, index) { return ((0, preact_1.h)(react_1.SwiperSlide, { key: index },
                (0, preact_1.h)("div", { class: "ugc-carousel__parent-container", style: { backgroundImage: "url(".concat(review.backgroundImg, ")") } },
                    (0, preact_1.h)("div", { class: "ugc-carousel__text-container" },
                        (0, preact_1.h)("div", { class: "ugc-carousel__top-container" },
                            (0, preact_1.h)("p", { class: "ugc-carousel__review-header" }, review.title),
                            (0, preact_1.h)("div", { class: "ugc-carousel__profile-container" },
                                (0, preact_1.h)("img", { class: "ugc-carousel__profile-icon", src: icon_1.PROFILE_ICON, alt: "Profile Icon", loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                                (0, preact_1.h)("p", { class: "ugc-carousel__review-name" }, review.author))),
                        (0, preact_1.h)("div", { class: "ugc-carousel__bottom-container" },
                            (0, preact_1.h)("div", { class: "ugc-carousel__verified-container" },
                                (0, preact_1.h)("img", { class: "ugc-carousel__stars-icon", src: icon_1.UGC_STARS, alt: "FIVE STAR", loading: window.isLazyVPTest ? 'lazy' : 'eager' }),
                                (0, preact_1.h)("p", { class: "ugc-carousel__verified-purchase" }, "Verified Purchase")),
                            (0, preact_1.h)("p", { class: "ugc-carousel__review-text" }, review.body)))))); })),
        isNewUGC && ((0, preact_1.h)("a", { class: "uro-vp__info redesignAb", href: location.pathname == '/' ? "/collections/shop-all" : "#anchor--product-title" },
            (0, preact_1.h)("button", { class: "button button--".concat(color) }, "Shop Now")))));
};
exports.default = UgcCarouselMain;
